/**
* In View Parent function is used to retrieve the Patient details, physician info and patient info details and its * functions declare this file
**/
import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { goBack, convertTimeFormat, convertS3privateToPublic } from './../../../services/UtilsService';
import ApiService from './../../../services/ApiService';
import {
	convertDOBtoAge,
	convertDOBtoMonth,
	formatMeasurement,
} from "./../../../services/UtilsService";
// import Filter from "./../../../shared/components/Filter";
import ChartModal from "./../../../shared/modals/ChartModal";
import MeasurementChart from "./../../../shared/modals/MeasurementChartModal";
import MessageModal from "./../../../shared/modals/MessageModal";
import AddMedicalInfoModal from "./../../../shared/modals/AddMedicalInfoModal";
import DevelopmentModal from "./../../../shared/modals/DevelopmentModal";
import VaccinationModal from "./../../../shared/modals/VaccinationModal";
import MedicalIssueModal from "./../../../shared/modals/MedicalIssueModal";
import AppointmentsModal from "./../../../shared/modals/AppointmentsModal";
import { useTranslation } from 'react-i18next';

function ViewParent() {
	// Initial variable declaration
	// Extract the `id` from URL params
	const { id } = useParams();

	// Separate state variables for parent and family member data
	const [parentData, setParentData] = useState({});
	const [modal, setModal] = useState({});
	const [familyData, setFamilyData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	// const [count, setCount] = useState(0);
	const [message, setMessage] = useState({});
	// const [request, setRequest] = useState({
	// 	page: 0,
	// 	limit: 10,
	// 	clinics: [],
	// 	age_range: [],
	// 	sort: "updated",
	// });
    const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();

	// Fetch parent data
	useEffect(() => {
		if (id) {
			(async () => {
				try {
					var response = await ApiService.getParent(id);
					if (response.status === 200) {
						setParentData(response.data);  // Set the parent data in a separate state
					}
				} catch (error) {
					console.error('Error fetching parent data:', error);
				}
			})();
		}
	}, [id]);

	// Fetch family members data
	useEffect(() => { 
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const response = await ApiService.listParentMember();
				if (response.status === 200) {
					// Filter family members that match the parent ID
					const filteredData = response.data.data.filter(
						member => String(member.parent).trim() === String(id).trim()
					);

					setFamilyData(filteredData);  // Set the family members data
					// setCount(filteredData.length); // Set the count based on filtered data
				}
			} catch (error) {
				console.error('Error fetching family member data:', error);
			} finally {
				setIsLoading(false);
			}
		};
		if (id) {
			fetchData();
		}
	}, [id]); // Add `id` to the dependency array

	
	//To close message modal
	const closeMessage = () => {
		setMessage({});
	};

	//callback function
	const handleClose = () => setModal({});

	return (
		<main id="main" className="main">
			{/*import DevelopmentModal*/}
			{Object.keys(modal).length !== 0 && modal.development && (
				<DevelopmentModal data={modal} handleClose={handleClose} />
			)}

			{/*import VaccinationModal*/}
			{Object.keys(modal).length !== 0 && modal.vaccination && (
				<VaccinationModal data={modal} handleClose={handleClose} />
			)}

			{/*import MedicalIssueModal*/}
			{Object.keys(modal).length !== 0 && modal.medication && (
				<MedicalIssueModal data={modal} handleClose={handleClose} />
			)}

			{/*import AppointmentsModal*/}
			{Object.keys(modal).length !== 0 && modal.appointment && (
				<AppointmentsModal data={modal} handleClose={handleClose} />
			)}

			{/*import ChartModal*/}
			{Object.keys(modal).length !== 0 && modal.chart && (
				<ChartModal data={modal} handleClose={handleClose} />
			)}

			{/*import MeasurementChart*/}
			{Object.keys(modal).length !== 0 && modal.measurement && (
				<MeasurementChart data={modal} handleClose={handleClose} />
			)}

			{/*MessageModal*/}
			{Object.keys(message).length !== 0 && (
				<MessageModal data={message} handleClose={closeMessage} />
			)}

			{/*AddMedicalInfoModal*/}
			{Object.keys(modal).length !== 0 && modal.addInfo && (
				<AddMedicalInfoModal data={modal} handleClose={handleClose} />
			)}

			{/* <!-- Page Title Section --> */}
			<div className="pagetitle clearfix">
				<div className="float-start">
					<h1>{t('profile.viewParentInfo')}</h1>
					<nav>
						<ol className="breadcrumb">
							<li className="breadcrumb-item"><Link to='/hospital/admin/dashboard'>{t('sidebar.home')}</Link></li>
							<li className="breadcrumb-item"><Link to='/hospital/admin/parents'>{t('sidebar.parents')}</Link></li>
							<li className="breadcrumb-item active">{t('profile.viewParentInfo')}</li>
						</ol>
					</nav>
				</div>
				<div className="float-end mt-2 me-1">
					<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>				</div>{/* <!-- End Buttons --> */}
			</div>
			{/* 		
			<!-- End Page Title Section -->
			<!-- Page Content Section --> */}
			<section>
				<div className="row">
					{/* <!--ProfileImg--> */}
					<div className="col-lg-3">
						<div className="card profile-img">
							<div className="card-body">
								<div className="top-bar">
									{(parentData && parentData?.parentInfo && parentData?.parentInfo?.photo === 'default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/user-avatar.png" alt="IMG" />}
									{(parentData && parentData?.parentInfo && parentData?.parentInfo?.photo !== 'default.png') && <img src={convertS3privateToPublic(parentData?.parentInfo?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
									<h1 className="text-capitalize">{parentData.parentInfo?.first_name ? parentData.parentInfo?.first_name + ' ' + parentData.parentInfo?.last_name : '--'}</h1>
									{/* <!-- <h6 className="text-tmBlue"></h6> --> */}
								</div>
								<div className="center-bar clearfix">
									<div className="d-flex align-items-center mb-4">
										<div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
											<i className="iconly-Bold-Send"></i>
										</div>
										<div className="ms-2">
											<p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>{t('profile.email')}</p>
											<span className="h6 text-dark" style={{ wordBreak : "break-word"}}>{parentData.parentInfo?.email}</span>
										</div>
									</div>
									<div className="d-flex align-items-center mb-4">
										<div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
											<i className="iconly-Bold-Calling"></i>
										</div>
										<div className="ms-2">
											<p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>{t('profile.phone')}</p>
											<span className="h6 text-dark">{parentData.parentInfo?.mobileNumber ? (parentData.parentInfo?.countryCode + ' ' + parentData.parentInfo?.mobileNumber) : '--'}</span>
										</div>
									</div>
								</div>
								<div className="d-grid mt-4">
									<Link to={'/hospital/admin/edit-parent/' + id} className={`btn btn-block ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-outline-tmBlue'}`}>
										<i className="ri-edit-2-fill align-middle"></i> {t('profile.editProfile')}
									</Link>
								</div>
							</div>
						</div>
					</div>
					{/* <!--ProfileInfo--> */}
					<div className="col-lg-9">
						<div className="card profile-info">
							<div className="card-body pt-4">
								<div className="row">
									<div className="col-xxl-12 px-3 mb-5">
										<div className={`secTitle ${role === 4 ? 'admin-secTitle' : ''}`}>
											<h1>{t('profile.PatientInfo')}</h1>
										</div>
										<div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
											<h6>{t('profile.location')}</h6>
											<p>{parentData.parentInfo && parentData.parentInfo.address_one ? 'Address One: ' + parentData.parentInfo.address_one + ', ' : ''}{parentData.parentInfo && parentData.parentInfo.address_one && <br />}
												{parentData.parentInfo && parentData.parentInfo.address_two ? 'Address Two: ' + parentData.parentInfo.address_two + ', ' : ''}{parentData.parentInfo && parentData.parentInfo.address_two && <br />}
												{(parentData.parentInfo && parentData.parentInfo.city) ? 'City: ' + parentData.parentInfo.city + ', ' : ''}{parentData.parentInfo && parentData.parentInfo.city && <br />}
												{(parentData.parentInfo && parentData.parentInfo.state) ? 'State: ' + parentData.parentInfo.state + ', ' : ''}{parentData.parentInfo && parentData.parentInfo.state && <br />}
												{(parentData.parentInfo && parentData.parentInfo.zipcode) ? 'Zipcode: ' + parentData.parentInfo.zipcode : ''}{parentData.parentInfo && parentData.parentInfo.zipcode && <br />}
												{!(parentData.parentInfo && (parentData.parentInfo.city || parentData.parentInfo.state || parentData.parentInfo.zipcode)) ? '--' : ''}
											</p>
										</div>
										<div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
											<h6>{t('profile.familyMember')}</h6>
											<p>{parentData.parentInfo?.members}</p>
										</div>
									</div>
								</div>
								{/* <!--ChildInfo--> */}
								{/*Child Table*/}
								<div className="row my-3">
									<div className="col-xxl-12">
									<div className={`secTitle ${role === 4 ? 'admin-secTitle' : ''}`}>
											<h1>{t('table.memberDetails')}</h1>
										</div>
										<div className="table-responsive">
											<table className="table table-borderless theme-table">
												<thead>
													<tr>
														<th scope="col">{t('table.memberDetails')}</th>
														{/*  <th scope="col" className="text-center">
														{constantVariables.table.analytics}
														</th> */}
														<th scope="col" className="text-center">
															{t('table.weight')}
														</th>
														<th scope="col" className="text-center">
															{t('table.height')}
														</th>
														<th scope="col" className="text-center">
															{t('table.head')}
														</th>
														<th scope="col" className="text-center">
															{t('table.bloodGroup')}
														</th>
														<th scope="col" className="text-center">
															{t('table.description')}
														</th>
														{/* <th scope="col" className="text-center">
															{constantVariables.table.add}
														</th> */}
														{/*<th scope="col" className="text-center">{constantVariables.table.temperature}</th>
															<th scope="col" className="text-center">{constantVariables.table.heartRate}</th>
															<th scope="col" className="text-center">{constantVariables.table.bloodGlucose}</th>*/}
													</tr>
												</thead>
												<tbody>
													{Array.isArray(familyData) && familyData.length > 0 ? (
														familyData.map((item, i) => (
															<tr
																key={i}
																className={item.gender === 0 ? "male" : "female"}
															>
																<td>
																	<div className="d-flex align-items-center ps-1z text-capitalize">
																		<div className="avtar-img">
																			<span className="rounded-circle">
																				{item?.photo === "default.png" ? (
																					<img
																						src="/assets/img/user-avatar.png"
																						alt="UN"
																					/>
																				) : (
																					<img
																						src={convertS3privateToPublic(item?.photo)}
																						alt="UN"
																					/>
																				)}
																			</span>
																		</div>
																		<div className="ms-3">
																			<Link
																				to={"/hospital/admin/view-children/" + item?.id}
																			>
																				<h5 className="table-title fw-bold">
																					{item.name}
																				</h5>
																			</Link>
																			<p className={`table-subtitle ${role === 4 ? 'admin-table-subtitle' : ''}`}>
																				<span>
																					{item.gender === 0 ? "Boy" : "Girl"}
																				</span>{" "}
																				- {convertDOBtoAge(item.dob, t)}
																			</p>
																			<div className="icon-link">
																				<span
																					style={{ cursor: "pointer" }}
																					onClick={() =>
																						setModal({
																							development: true,
																							id: item.id,
																							parent: item.parent,
																							name: item.name,
																						})
																					}
																					className="me-1 text-tmGreen"
																				>
																					<i
																						className="fa-solid fa-chart-column"
																						title="Development"
																					></i>
																				</span>
																				<span
																					style={{ cursor: "pointer" }}
																					className={`me-1 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}
																					onClick={() =>
																						setModal({
																							vaccination: true,
																							member: item.id,
																							dob: convertDOBtoMonth(item.dob),
																							name: item.name,
																							parent: item.parent,
																						})
																					}
																				>
																					<i
																						className="fa-solid fa-syringe"
																						title="Vaccination"
																					></i>
																				</span>
																				<span
																					style={{ cursor: "pointer" }}
																					className="me-1 text-tmAquaGreen"
																					onClick={() =>
																						setModal({
																							medication: true,
																							member: item.id,
																							name: item.name,
																							parent: item.parent,
																						})
																					}
																				>
																					<i
																						className="fa-solid fa-hospital-user"
																						title="Medical Issue"
																					></i>
																				</span>
																				<span
																					style={{ cursor: "pointer" }}
																					className="me-1 text-tmPurple"
																				>
																					<i
																						className="fa-regular fa-calendar-days"
																						onClick={() =>
																							setModal({
																								appointment: true,
																								member: item.id,
																								name: item.name,
																							})
																						}
																						title="Appointments"
																					></i>
																				</span>
																				{role===4 && <>
																				<span
																				style={{ cursor: "pointer",fontSize: "12px"}}
																				className="py-0 px-1 btn btn-xs btn-tmAquaGreen add-border-radius-0-2rem"
																				onClick={() =>
																					setModal({
																					addInfo: true,
																					member: item.id,
																					name: item.name
																					})
																				}
																				title="AddMedicalInfo"
																				>
																				<i
																					className="ri-add-line align-middle"
																				></i>Add
																				</span>
																				</>}
																			</div>
																		</div>
																	</div>
																</td>
																{/*  <td className="text-center">
																	<span>
																		{item?.interactiontime
																		? item.interactiontime
																		: "00:00:00"}
																	</span>
																	</td> */}
																<td className="text-center">
																	<span
																		className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}
																		onClick={() =>
																			setModal({
																				measurement: true,
																				member: item.id,
																				chartName: "Weight",
																				gender: item.gender,
																				parent: item.parent,
																				dob: item?.dob,
																				name: item.name,
																			})
																		}
																	>
																		{item?.latest_weight
																			? formatMeasurement(item.latest_weight) + " kg"
																			: "--"}
																	</span>
																</td>
																<td className="text-center">
																	<span
																		className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}
																		onClick={() =>
																			setModal({
																				measurement: true,
																				member: item.id,
																				chartName: "Height",
																				gender: item.gender,
																				parent: item.parent,
																				dob: item?.dob,
																				name: item.name,
																			})
																		}
																	>
																		{item?.latest_height
																			? formatMeasurement(item.latest_height) + " cm"
																			: "--"}
																	</span>
																</td>
																<td className="text-center">
																	<span>
																		{item?.latest_head_circumference
																			? formatMeasurement(item.latest_head_circumference) + " cm"
																			: "--"}
																	</span>
																</td>
																<td className="text-center">
																	<span>
																		{item?.blood_group ? item.blood_group : "--"}
																	</span>
																</td>
																<td className="text-center">
																	<span
																		onClick={() =>
																			setMessage({
																				show: true,
																				description: true,
																				title: `${item.name}${t('common.possessive_suffix')} ${t('table.description')}`,
																				message: item.description,
																			})
																		}
																		className={`table-link ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}
																	>
																		<i
																			className="fa-solid fa-file-lines"
																			toggle="tooltip"
																			placement="top"
																			title="Description"
																		/>
																	</span>
																</td>
																{/* <td className="text-center">
																	<Link
																		className="table-link text-tmBlue"
																		onClick={() =>
																			setModal({
																				addInfo: true,
																				member: item.id,
																				name: item.name
																			})
																		}
																	>
																		<i className="ri-add-box-fill align-middle fw-normal"></i>
																	</Link>
																</td> */}
																{/*<td className="text-center"><span className={`table-link ${role === 4 ? 'admin-table-link' : ''}`} onClick={()=>setModal({chart:true,member:item.id,name:item.name,chartName:3,parent:item.parent,type:'Temperature'})}>{item?.latest_temperature ? item?.latest_temperature +' C°' : '--'}</span></td>
																	<td className="text-center"><span className={`table-link ${role === 4 ? 'admin-table-link' : ''}`} onClick={()=>setModal({chart:true,member:item.id,name:item.name,chartName:1,parent:item.parent,type:'Heart rate'})}>{item?.latest_heartrate ? item?.latest_heartrate +'(bpm)' : '--'}</span></td>
																	<td className="text-center"><span className={`table-link ${role === 4 ? 'admin-table-link' : ''}`} onClick={()=>setModal({chart:true,member:item.id,name:item.name,chartName:2,parent:item.parent,type:'Blood Glucose'})}>{item?.latest_bloodglucose ? item?.latest_bloodglucose +'(mg/dL)' : '--'}</span></td>*/}
															</tr>
														))
													) : (
														!isLoading && (
															<tr>
																<td colSpan="7" className="text-center">
																	{t('common.noRecord')}
																</td>
															</tr>
														)
													)}

												</tbody>
											</table>
										</div>
									</div>
								</div>
								{/*End Table*/}
								{/*Physician Info*/}
								<div className="row">
									<div className="col-xxl-12 px-3 mb-5">
										<div className={`secTitle ${role === 4 ? 'admin-secTitle' : ''}`}>
											<h1>{t('profile.physicianInfo')}</h1>
										</div>
										<div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
											<div className="table-responsive">
												<table className="table table-borderless theme-table">
													<thead>
														<tr>
															<th scope="col">{t('sidebar.physician')}</th>
															<th scope="col">{t('profile.visitingDays')}</th>
															<th scope="col">{t('profile.visitingHours')}</th>
															<th scope="col">{t('profile.consultingDuration')}</th>
														</tr>
													</thead>
													{parentData && parentData?.physicianInfo?.length ? (
														<tbody>
															{parentData && parentData.physicianInfo && parentData.physicianInfo.length !== 0 && parentData.physicianInfo.map((item, i) => (<tr className="text-capitalize" key={i}>
																<td className="prty-td">
																	<span >
																		<h5 className="table-title">{item?.physicianname}</h5>
																	</span>
																</td>
																<td>{item.days && item?.days.length > 0 ? (
																	 item?.days
																	.map(day =>[day.trim()] || '--') 
																	.reduce((acc, curr, index) => (
																	<>
																		{acc}
																		{index > 0 && ', '}
																		{curr}
																	</>
																	), '')) : (
																		'--' // Change: Added fallback for no days
																	)}
																</td>
																{/*<td>{item?.startTime ? convertTimeFormat(item?.startTime) : ''} to {item?.endTime ? convertTimeFormat(item?.endTime) :''}</td>*/}
																<td>
																	{item?.startTime ? convertTimeFormat(item?.startTime) : '--'}
																	{item?.startTime && item?.endTime && ' to '}
																	{item?.endTime && convertTimeFormat(item?.endTime)}
																</td>
																<td className="text-center">
																	{item?.consultingDuration}
																</td>

															</tr>))}
														</tbody>
													) : (
														<tbody>
															<tr>
																<td colSpan="3" className="text-center">{t('common.noRecord')}</td>
															</tr>
														</tbody>
													)}
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- End Page Content Section --> */}
		</main>
	);
}
export default ViewParent;;
